module.exports = __webpack_public_path__ + "static/media/background.537e4466.mp4";